import PropTypes from 'prop-types';
import styles from './FJMobilePreviewFooter.module.less';
import FacebookIcon from '../../../../assets/svg/facebook.svg?react';
import TwitterIcon from '../../../../assets/svg/twitter.svg?react';
// import TumblrIcon from '../../../../assets/svg/tumblr.svg?react';
import ShareIcon from '../../../../assets/svg/link.svg?react';
import FJConstant from '../../../../constants/FJConstant';
import DeleteIcon from '../../../../assets/svg/mobile-delete.svg?react';
import ShareSmallIcon from '../../../../assets/svg/mobile-share.svg?react';
import ComparisonIcon from '../../../../assets/svg/mobile-comparison.svg?react';
import InfoIcon from '../../../../assets/svg/mobile-info.svg?react';
import DownloadIcon from '../../../../assets/svg/mobile-download.svg?react';
import classNames from 'classnames';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJMobileFooterBox from '../../../../common/components/FJMobileFooterBox/FJMobileFooterBox';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import FJLocalStore from '../../../../store/FJLocalStore';
import { useState, useRef, useMemo } from 'react';
import FJUtil from '../../../../util/FJUtil';
import CopyIcon from '../../../../assets/svg/copy.svg?react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJMessageStore from '../../../../store/FJMessageStore';

const shareList = [
    { type: FJConstant.FACEBOOK, icon: <FacebookIcon />, name: 'facebook' },
    { type: FJConstant.TWITTER, icon: <TwitterIcon />, name: 'twitter' },
    // { type: FJConstant.TUMBLR, icon: <TumblrIcon />, name: 'tumblr' },
    { type: FJConstant.COPY_LINK, icon: <ShareIcon />, name: 'link-copy' },
];
const FJMobilePreviewFooter = props => {
    const {
        data,
        shareToSociety,
        onDownload,
        onDelete,
        isShowComparison,
        isComparison,
        setIsComparison,
        canComparison,
    } = props;
    const { type, textToImagePrompt } = data;
    const shareBoxRef = useRef(null);
    const infoBoxRef = useRef(null);

    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);

    const isShowDeleteIcon = type === FJConstant.HISTORY;

    const infoList = useMemo(() => {
        return FJUtil.parseModalInfoList(data);
    }, [data]);
    const _onMouseDown = e => {
        FJUtil.forbidEvent(e);
        if (isComparison) return;
        if (!canComparison) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
        } else {
            setIsComparison(true);
        }
        const _onMouseUp = () => {
            setIsComparison(false);
            FJUtil.removeEvent(document.body, 'touchend', _onMouseUp);
        };
        FJUtil.addEvent(window, 'touchend', _onMouseUp);
    };
    const _onShareClick = e => {
        FJUtil.forbidEvent(e);
        if (shareBoxRef.current) {
            shareBoxRef.current.show();
        }
    };
    const _onInfoClick = e => {
        FJUtil.forbidEvent(e);
        if (infoBoxRef.current) {
            infoBoxRef.current.show();
        }
    };

    const _onDownload = () => {
        setStateIsDownloadLoading(true);
        onDownload(() => {
            setStateIsDownloadLoading(false);
        });
    };
    const _copyTextToImagePrompt = () => {
        FJUtil.copyText(textToImagePrompt);
        FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
    };
    const _renderShareBox = () => {
        return (
            <FJMobileFooterBox ref={shareBoxRef} className={styles.share_box} title={FJLocalStore._('share')}>
                <div className={styles.share_list}>
                    {shareList.map(item => {
                        const { type, icon, name } = item;
                        return (
                            <div
                                key={type}
                                onClick={() => {
                                    shareToSociety(item.type);
                                }}
                                className={styles.share_item}
                            >
                                <div className={classNames(styles.share_icon, styles[name])}>{icon}</div>
                                <span className={styles.share_name}>{FJLocalStore._(name)}</span>
                            </div>
                        );
                    })}
                </div>
            </FJMobileFooterBox>
        );
    };
    const _renderInfoBox = () => {
        return (
            <FJMobileFooterBox ref={infoBoxRef} className={styles.info_box} title={FJLocalStore._('info_preview')}>
                {textToImagePrompt && (
                    <div className={styles.info_item_prompt}>
                        <div className={styles.info_title_box}>
                            <span className={styles.info_title}>{FJLocalStore._('prompt')}</span>
                            <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                <CopyIcon />
                            </div>
                        </div>
                        <FJVerticalScroller className={classNames(styles.info_content_prompt)}>
                            {textToImagePrompt}
                        </FJVerticalScroller>
                    </div>
                )}
                <div className={styles.info_list}>
                    {infoList.map((item, index) => (
                        <div className={styles.info_item} key={index}>
                            <span className={styles.info_title}>{FJLocalStore._(item.title).replaceAll(':', '')}</span>
                            <span className={styles.info_content}>{item.content}</span>
                        </div>
                    ))}
                </div>
            </FJMobileFooterBox>
        );
    };
    return (
        <div className={styles.footer}>
            <div className={styles.footer_left}>
                {isShowComparison && (
                    <div className={styles.icon_box} onTouchStart={_onMouseDown}>
                        <ComparisonIcon />
                    </div>
                )}
                <div className={styles.icon_box} onClick={_onShareClick}>
                    <ShareSmallIcon />
                </div>
                <div className={styles.icon_box} onClick={_onInfoClick}>
                    <InfoIcon />
                </div>
                {isShowDeleteIcon && (
                    <div className={styles.icon_box} onClick={onDelete}>
                        <DeleteIcon />
                    </div>
                )}
            </div>
            <FJHoverBoardGradation
                active={true}
                borderRadius={20}
                className={styles.download_box}
                contentClassName={styles.download}
            >
                <FJIconButton
                    className={styles.download_btn}
                    text={FJLocalStore._('download')}
                    icon={<DownloadIcon />}
                    textClassName={styles.download_text}
                    isLoading={stateIsDownloadLoading}
                    onClick={_onDownload}
                    strokeColor={'#FFF'}
                />
            </FJHoverBoardGradation>
            {_renderShareBox()}
            {_renderInfoBox()}
        </div>
    );
};
FJMobilePreviewFooter.propTypes = {
    data: PropTypes.object,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    shareToSociety: PropTypes.func,
    isShowComparison: PropTypes.bool,
    setIsComparison: PropTypes.func,
    isComparison: PropTypes.bool,
    canComparison: PropTypes.bool,
};
export default FJMobilePreviewFooter;
